import React, { useState, useEffect } from "react";
import "../../ViewInfo.css";
import { TextField, Button, MenuItem, Menu } from "@mui/material";
import { Get_One_Nested_Prop_From_MongoDB } from "../../../api/Get_One_Nested_Prop_From_MongoDB";
import { useParams } from "react-router-dom";
import { Update_To_MongoDB_By_ID } from "../../../api/Update_To_MongoDB_By_ID";
import removeUnderscores from "../../../../functions/removeUnderscores";
import { StudentuseAuth } from "../../../security/StudentUseAuth";
import { Student_Get_One_Nested_Prop_From_MongoDB } from "../../../api/Student_Get_One_Nested_Prop_From_MongoDB";
import { Student_Update_To_MongoDB_By_ID } from "../../../api/Student_Update_To_MongoDB_By_ID";
import { Link } from "react-router-dom";
import WEFChangePage from "../../../components/ChangePage/WEFChangePage";

function ViewSENDInfo() {
  const { id } = useParams();
  const { logoutStudent } = StudentuseAuth();

  const [formSENDInfo, setformSENDInfo] = useState({
    SEND_Mobility_Aid: "",
    SEND_Mobility_Aid_Further_Info: "",
    SEND_Access_Needs: "",
    SEND_Access_Needs_Further_Info: "",
    SEND_Disabilities: "",
    SEND_Disabilities_Further_Info: "",
    SEND_Learning_Disabilities: "",
    SEND_Learning_Disabilities_Further_Info: "",
  });

  const [SEFProgress, setSEFProgress] = useState({
    SENDInfo: "",
  });

  useEffect(() => {
    Student_Get_One_Nested_Prop_From_MongoDB(
      "Registers_2025",
      "All",
      localStorage.getItem("Student_id"),

      "SEFSENDInfo",
      setformSENDInfo,
      logoutStudent
    );
    Student_Get_One_Nested_Prop_From_MongoDB(
      "Registers_2025",
      "All",
      localStorage.getItem("Student_id"),

      "SEFProgress",
      setSEFProgress,
      logoutStudent
    );
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setformSENDInfo((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const [status, setStatus] = useState(false);

  const handleSaveProgress = () => {
    Student_Update_To_MongoDB_By_ID(
      {
        SEFSENDInfo: formSENDInfo,
        "SEFProgress.SENDInfo": "In_Progress",
      },
      "Registers_2025",
      "All",
      setStatus,
      localStorage.getItem("Student_id"),

      "Your progress has been saved, you may now navigate to another page using the buttons at the bottom or close this tab",
      logoutStudent
    );
    setPageButtonStatus(true);
  };

  const handleSubmit = () => {
    Student_Update_To_MongoDB_By_ID(
      {
        SEFSENDInfo: formSENDInfo,
        // SEFProgress: { SENDInfo: "Complete" },
        "SEFProgress.SENDInfo": "Complete",
      },
      "Registers_2025",
      "All",
      setStatus,
      localStorage.getItem("Student_id"),

      "This page has been submitted, you may now navigate to another page using the buttons at the bottom or close this tab",
      logoutStudent
    );
    setSEFProgress({
      SENDInfo: "Complete",
    });
    setPageButtonStatus(true);
  };

  const isFormComplete =
    formSENDInfo &&
    (formSENDInfo.SEND_Mobility_Aid === "No" ||
      formSENDInfo.SEND_Mobility_Aid_Further_Info) &&
    (formSENDInfo.SEND_Access_Needs === "No" ||
      formSENDInfo.SEND_Access_Needs_Further_Info) &&
    (formSENDInfo.SEND_Disabilities === "No" ||
      formSENDInfo.SEND_Disabilities_Further_Info) &&
    (formSENDInfo.SEND_Learning_Disabilities === "No" ||
      formSENDInfo.SEND_Learning_Disabilities_Further_Info);

  console.log("formSENDInfo");
  console.log(formSENDInfo);

  const [PageButtonStatus, setPageButtonStatus] = useState(false);

  return (
    <div className="view-basic-info-container">
      <h1>
        Student Special Educational Needs and Disabilities (SEND) Requirements:
      </h1>
      {SEFProgress &&
      SEFProgress.SENDInfo &&
      (SEFProgress.SENDInfo === "Complete" ||
        SEFProgress.SENDInfo === "Awaiting_Review") ? (
        <strong>
          If you need to make further changes, please contact InvestIN at
          info@investin.org or speak to your known contact
        </strong>
      ) : (
        ""
      )}

      <form className="view-basic-info-form">
        Does the student use mobility aids or have any physical mobility needs
        that we should be aware of? (e.g. wheelchair)
        <TextField
          label={removeUnderscores("Mobility Aid")}
          variant="outlined"
          fullWidth
          required
          name="SEND_Mobility_Aid"
          value={formSENDInfo?.SEND_Mobility_Aid}
          onChange={handleChange}
          InputProps={{
            style: {
              backgroundColor: "white",
              textAlign: "left",
              color: "black", // Set the font color to black
            },
          }}
          InputLabelProps={{
            style: {
              fontSize: "1.2rem", // Increase the font size of the label
              color: "black", // Set the label color to black
            },
          }}
          select
        >
          <MenuItem value="">-----</MenuItem>
          <MenuItem value="Yes">Yes</MenuItem>
          <MenuItem value="No">No</MenuItem>
        </TextField>
        {formSENDInfo?.SEND_Mobility_Aid === "Yes" ? (
          <>
            Please explain what the mobility or access needs are below (e.g.
            student uses a wheelchair and requires use of disabled toilet).
            <TextField
              label={removeUnderscores("Mobility Aid Further Information")}
              variant="outlined"
              fullWidth
              required
              name="SEND_Mobility_Aid_Further_Info"
              value={formSENDInfo?.SEND_Mobility_Aid_Further_Info}
              onChange={handleChange}
              InputProps={{
                style: {
                  backgroundColor: "white",
                  textAlign: "left",
                  color: "black", // Set the font color to black
                },
              }}
              InputLabelProps={{
                style: {
                  fontSize: "1.2rem", // Increase the font size of the label
                  color: "black", // Set the label color to black
                },
              }}
            />
          </>
        ) : (
          <></>
        )}
        Does the student have any access needs that we should be aware of? (e.g.
        hearing difficulties)
        <TextField
          label={removeUnderscores("Access Needs")}
          variant="outlined"
          fullWidth
          required
          name="SEND_Access_Needs"
          value={formSENDInfo?.SEND_Access_Needs}
          onChange={handleChange}
          InputProps={{
            style: {
              backgroundColor: "white",
              textAlign: "left",
              color: "black", // Set the font color to black
            },
          }}
          InputLabelProps={{
            style: {
              fontSize: "1.2rem", // Increase the font size of the label
              color: "black", // Set the label color to black
            },
          }}
          select
        >
          <MenuItem value="">-----</MenuItem>
          <MenuItem value="Yes">Yes</MenuItem>
          <MenuItem value="No">No</MenuItem>
        </TextField>
        {formSENDInfo?.SEND_Access_Needs === "Yes" ? (
          <>
            Please outline the access need for the student (e.g. student is
            partially deaf and needs to sit near the speaker to fully
            participate).
            <TextField
              label={removeUnderscores("Access Needs Further Information")}
              variant="outlined"
              fullWidth
              required
              name="SEND_Access_Needs_Further_Info"
              value={formSENDInfo?.SEND_Access_Needs_Further_Info}
              onChange={handleChange}
              InputProps={{
                style: {
                  backgroundColor: "white",
                  textAlign: "left",
                  color: "black", // Set the font color to black
                },
              }}
              InputLabelProps={{
                style: {
                  fontSize: "1.2rem", // Increase the font size of the label
                  color: "black", // Set the label color to black
                },
              }}
            />
          </>
        ) : (
          <></>
        )}
        Does the student have any disabilities that we should be aware of that
        have not been already mentioned?
        <TextField
          label={removeUnderscores("Disabilities")}
          variant="outlined"
          fullWidth
          required
          name="SEND_Disabilities"
          value={formSENDInfo?.SEND_Disabilities}
          onChange={handleChange}
          InputProps={{
            style: {
              backgroundColor: "white",
              textAlign: "left",
              color: "black", // Set the font color to black
            },
          }}
          InputLabelProps={{
            style: {
              fontSize: "1.2rem", // Increase the font size of the label
              color: "black", // Set the label color to black
            },
          }}
          select
        >
          <MenuItem value="">-----</MenuItem>
          <MenuItem value="Yes">Yes</MenuItem>
          <MenuItem value="No">No</MenuItem>
        </TextField>
        {formSENDInfo?.SEND_Disabilities === "Yes" ? (
          <>
            Please detail what, if any, additional support the student may
            require (e.g. student is blind and requires course material in
            advance to pre-load on their brail software).
            <TextField
              label={removeUnderscores("Disability Further Information")}
              variant="outlined"
              fullWidth
              required
              name="SEND_Disabilities_Further_Info"
              value={formSENDInfo?.SEND_Disabilities_Further_Info}
              onChange={handleChange}
              InputProps={{
                style: {
                  backgroundColor: "white",
                  textAlign: "left",
                  color: "black", // Set the font color to black
                },
              }}
              InputLabelProps={{
                style: {
                  fontSize: "1.2rem", // Increase the font size of the label
                  color: "black", // Set the label color to black
                },
              }}
            />
          </>
        ) : (
          <></>
        )}
        Does the student have any learning difficulties/disabilities that we
        should be aware of?
        <TextField
          label={removeUnderscores("Learning Difficulties")}
          variant="outlined"
          fullWidth
          required
          name="SEND_Learning_Disabilities"
          value={formSENDInfo?.SEND_Learning_Disabilities}
          onChange={handleChange}
          InputProps={{
            style: {
              backgroundColor: "white",
              textAlign: "left",
              color: "black", // Set the font color to black
            },
          }}
          InputLabelProps={{
            style: {
              fontSize: "1.2rem", // Increase the font size of the label
              color: "black", // Set the label color to black
            },
          }}
          select
        >
          <MenuItem value="">-----</MenuItem>
          <MenuItem value="Yes">Yes</MenuItem>
          <MenuItem value="No">No</MenuItem>
        </TextField>
        {formSENDInfo?.SEND_Learning_Disabilities === "Yes" ? (
          <>
            Please provide more information about their learning needs (e.g.
            student is dyslexic and requires a blue overlay for reading
            documents).
            <TextField
              label={removeUnderscores(
                "Learning Difficulties Further Information"
              )}
              variant="outlined"
              fullWidth
              required
              name="SEND_Learning_Disabilities_Further_Info"
              value={formSENDInfo?.SEND_Learning_Disabilities_Further_Info}
              onChange={handleChange}
              InputProps={{
                style: {
                  backgroundColor: "white",
                  textAlign: "left",
                  color: "black", // Set the font color to black
                },
              }}
              InputLabelProps={{
                style: {
                  fontSize: "1.2rem", // Increase the font size of the label
                  color: "black", // Set the label color to black
                },
              }}
            />
          </>
        ) : (
          <></>
        )}{" "}
        <WEFChangePage Page={"SENDInfo"} PageButtonStatus={PageButtonStatus} />
        <div className="view-basic-info-buttons">
          <Button
            variant="contained"
            color="primary"
            onClick={handleSaveProgress}
            disabled={
              status ||
              (SEFProgress &&
                SEFProgress.SENDInfo &&
                (SEFProgress.SENDInfo === "Complete" ||
                  SEFProgress.SENDInfo === "Awaiting_Review"))
            }
          >
            Save Progress
          </Button>
          <Button
            variant="contained"
            color="secondary"
            onClick={handleSubmit}
            disabled={
              !isFormComplete ||
              status ||
              (SEFProgress &&
                SEFProgress.SENDInfo &&
                (SEFProgress.SENDInfo === "Complete" ||
                  SEFProgress.SENDInfo === "Awaiting_Review"))
            }
          >
            Submit
          </Button>
        </div>
      </form>
    </div>
  );
}

export default ViewSENDInfo;
